import React from "react";
import "./Footer.css";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import RoomIcon from "@material-ui/icons/Room";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import SecurityIcon from "@material-ui/icons/Security";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

const socialLinks = [
    {
        icon: <TwitterIcon />,
        url: "https://twitter.com/plexarise",
        label: "Twitter",
    },
    {
        icon: <LinkedInIcon />,
        url: "https://www.linkedin.com/company/plexarise",
        label: "LinkedIn",
    },
    {
        icon: <FacebookIcon />,
        url: "https://www.facebook.com/plexarise",
        label: "Facebook",
    },
    {
        icon: <InstagramIcon />,
        url: "https://www.instagram.com/plexarise",
        label: "Instagram",
    },
    {
        icon: <GitHubIcon />,
        url: "https://github.com/plexarise",
        label: "GitHub",
    },
];

const navigationLinks = [
    { label: "About Studio", url: "https://www.plexarise.com/about" },
    { label: "Premium Services", url: "https://www.plexarise.com/services" },
    { label: "Case Library", url: "https://www.plexarise.com/portfolio" },
    { label: "Insights", url: "https://www.plexarise.com/blog" },
    { label: "Contact", url: "https://www.plexarise.com/contact" },
];

function Footer() {
    return (
        <footer className="footer">
            <div className="footer__glass">
                <div className="footer__brand">
                    <span className="footer__tag">Library Prime</span>
                    <h2>Where knowledge meets concierge-level service.</h2>
                    <p>
                        Designed for institutions that demand sophistication. Our dynamic
                        theming, intelligent circulation, and premium UX elevate every patron touchpoint.
                    </p>
                    <div className="footer__social">
                        {socialLinks.map((item) => (
                            <a
                                key={item.label}
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={item.label}
                            >
                                {item.icon}
                            </a>
                        ))}
                    </div>
                </div>

                <div className="footer__grid">
                    <div className="footer__column">
                        <h3>Visit</h3>
                        <div className="footer__item">
                            <RoomIcon />
                            <span>
                                Aura Library Experience Center,
                                <br />
                                Chennai 600042, Tamil Nadu, India
                            </span>
                        </div>
                        <div className="footer__item">
                            <AccessTimeIcon />
                            <span>
                                Concierge Hours:
                                <br />
                                Monday to Saturday, 9 AM – 6 PM
                            </span>
                        </div>
                    </div>

                    <div className="footer__column">
                        <h3>Connect</h3>
                        <div className="footer__item">
                            <MailOutlineIcon />
                            <span>support@plexarise.com</span>
                        </div>
                        <div className="footer__item">
                            <PhoneIcon />
                            <span>+91 98765 43210</span>
                        </div>
                        <div className="footer__item">
                            <LibraryBooksIcon />
                            <span>
                                Head Librarian
                                <br />
                                Dr. Rajesh Kumar, PhD
                            </span>
                        </div>
                    </div>

                    <div className="footer__column">
                        <h3>Navigate</h3>
                        <nav className="footer__links">
                            {navigationLinks.map((link) => (
                                <a
                                    key={link.label}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {link.label}
                                </a>
                            ))}
                        </nav>
                    </div>

                    <div className="footer__column">
                        <h3>Security</h3>
                        <div className="footer__item">
                            <SecurityIcon />
                            <span>
                                <strong>SSL/TLS Security: A+</strong>
                                <br />
                                Independently validated by{" "}
                                <a
                                    href="https://www.ssllabs.com/ssltest/analyze.html?d=lib.transnodes.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer__security-link"
                                >
                                    Qualys SSL Labs
                                </a>
                            </span>
                        </div>
                        <div className="footer__item">
                            <VerifiedUserIcon />
                            <span>
                                Transport layer security with strong encryption,
                                modern cipher suites, and protection against known
                                SSL/TLS vulnerabilities.
                            </span>
                        </div>
                        <div className="footer__security-note">
                            <small>
                                Note: SSL Labs testing evaluates TLS/HTTPS configuration only
                                and does not constitute a full application security assessment.
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <p>
                    © {new Date().getFullYear()} Plexarise Technologies · Crafted for premium library journeys.
                </p>
                <span>Aurora Luxe Theme · Powered by dynamic design tokens.</span>
            </div>
        </footer>
    );
}

export default Footer